import React from 'react';
import { translate } from  'react-admin';
import Button from '@material-ui/core/Button';

import TransitionLink from '../../../../components/TransitionLink';
import resourceConfig from './config';

const OpenButton = ({label, translate,...props}) => (
  <Button
    size={'small'}
    color={'primary'}
    {...props}
    component={TransitionLink}
    transitionTo={{
      params: {
        [resourceConfig.urlParamName]: 'open'
      }
    }}
  >
    {label || translate(`resources.${resourceConfig.name}.openAction`) }
  </Button>
);


export default translate(OpenButton);
